import commonEN from '../../modules/_common/common.en'
import commonPT from '../../modules/_common/common.pt'
import commonES from '../../modules/_common/common.es'
import duplicatesEn from '../../modules/serviceOrders/duplicates/_common/duplicates.en'
import duplicatesPt from '../../modules/serviceOrders/duplicates/_common/duplicates.pt'
import duplicatesEs from '../../modules/serviceOrders/duplicates/_common/duplicates.es'
import errorsEN from '../../modules/errors/_common/errors.en'
import errorsPT from '../../modules/errors/_common/errors.pt'
import errorsES from '../../modules/errors/_common/errors.es'
import editAssetEN from '../../modules/assets/edit/_common/editAsset.en'
import editAssetPT from '../../modules/assets/edit/_common/editAsset.pt'
import editAssetES from '../../modules/assets/edit/_common/editAsset.es'
import editBucketEN from '../../modules/buckets/edit/_common/editBucket.en'
import editBucketPT from '../../modules/buckets/edit/_common/editBucket.pt'
import editBucketES from '../../modules/buckets/edit/_common/editBucket.es'
import editChecklistEN from '../../modules/checklists/edit/_common/editChecklist.en'
import editChecklistPT from '../../modules/checklists/edit/_common/editChecklist.pt'
import editChecklistES from '../../modules/checklists/edit/_common/editChecklist.es'
import editFormV2EN from '../../modules/forms/editV2/_common/editForm.en'
import editFormV2PT from '../../modules/forms/editV2/_common/editForm.pt'
import editFormV2ES from '../../modules/forms/editV2/_common/editForm.es'
import editPermissionsPT from '../../modules/settings/editV2/_common/editPermissions.pt'
import editPermissionsES from '../../modules/settings/editV2/_common/editPermissions.es'
import editPermissionsEN from '../../modules/settings/editV2/_common/editPermissions.en'
import editPlaceEN from '../../modules/places/editV2/_common/editPlace.en'
import editPlacePT from '../../modules/places/editV2/_common/editPlace.pt'
import editPlaceES from '../../modules/places/editV2/_common/editPlace.es'
import editProfileEN from '../../modules/profiles/edit/_common/editProfile.en'
import editProfilePT from '../../modules/profiles/edit/_common/editProfile.pt'
import editProfileES from '../../modules/profiles/edit/_common/editProfile.es'
import editSegmentationEN from '../../modules/segments/edit/_common/editSegmentation.en'
import editSegmentationPT from '../../modules/segments/edit/_common/editSegmentation.pt'
import editSegmentationES from '../../modules/segments/edit/_common/editSegmentation.es'
import editSemaphoreEN from '../../modules/configs/editSemaphore/_common/editSemaphore.en'
import editServiceOrderAutomaticDistributionPT from '../../modules/configs/serviceOrderAutomaticDistribution/edit/_common/editServiceOrderAutomaticDistribution.pt'
import editServiceOrderAutomaticDistributionEN from '../../modules/configs/serviceOrderAutomaticDistribution/edit/_common/editServiceOrderAutomaticDistribution.en'
import editServiceOrderAutomaticDistributionES from '../../modules/configs/serviceOrderAutomaticDistribution/edit/_common/editServiceOrderAutomaticDistribution.es'
import editSemaphorePT from '../../modules/configs/editSemaphore/_common/editSemaphore.pt'
import editSemaphoreES from '../../modules/configs/editSemaphore/_common/editSemaphore.es'
import editServiceOrderEN from '../../modules/serviceOrders/editV2/_common/editServiceOrder.en'
import editServiceOrderPT from '../../modules/serviceOrders/editV2/_common/editServiceOrder.pt'
import editServiceOrderES from '../../modules/serviceOrders/editV2/_common/editServiceOrder.es'
import editUserEN from '../../modules/users/editV2/_common/editUser.en'
import editUserPT from '../../modules/users/editV2/_common/editUser.pt'
import editUserES from '../../modules/users/editV2/_common/editUser.es'
import levelsSettingsEN from '../../modules/places/levelsSettings/_common/levelsSettings.en'
import levelsSettingsPT from '../../modules/places/levelsSettings/_common/levelsSettings.pt'
import levelsSettingsES from '../../modules/places/levelsSettings/_common/levelsSettings.es'
import listAssetEN from '../../modules/assets/list/_common/listAsset.en'
import listAssetPT from '../../modules/assets/list/_common/listAsset.pt'
import listAssetES from '../../modules/assets/list/_common/listAsset.es'
import listBucketsEN from '../../modules/buckets/list/_common/listBuckets.en'
import listBucketsPT from '../../modules/buckets/list/_common/listBuckets.pt'
import listBucketsES from '../../modules/buckets/list/_common/listBuckets.es'
import listChecklistsEN from '../../modules/checklists/list/_common/listChecklists.en'
import listChecklistsPT from '../../modules/checklists/list/_common/listChecklists.pt'
import listChecklistsES from '../../modules/checklists/list/_common/listChecklists.es'
import listFormsEN from '../../modules/forms/list/_common/listForms.en'
import listFormsPT from '../../modules/forms/list/_common/listForms.pt'
import listFormsES from '../../modules/forms/list/_common/listForms.es'
import listLogsEN from '../../modules/logs/list/_common/listLogs.en'
import listLogsPT from '../../modules/logs/list/_common/listLogs.pt'
import listLogsES from '../../modules/logs/list/_common/listLogs.es'
import listNonComplianceEN from '../../modules/nonComplianceV2/list/_common/listNonCompliance.en'
import listNonCompliancePT from '../../modules/nonComplianceV2/list/_common/listNonCompliance.pt'
import listNonComplianceES from '../../modules/nonComplianceV2/list/_common/listNonCompliance.es'
import listPlaceNonComplianceEN from '../../modules/nonComplianceV2/placeList/_common/listPlaceNonCompliance.en'
import listPlaceNonCompliancePT from '../../modules/nonComplianceV2/placeList/_common/listPlaceNonCompliance.pt'
import listPlaceNonComplianceES from '../../modules/nonComplianceV2/placeList/_common/listPlaceNonCompliance.es'
import listPlacesEN from '../../modules/places/list/_common/listPlaces.en'
import listPlacesPT from '../../modules/places/list/_common/listPlaces.pt'
import listPlacesES from '../../modules/places/list/_common/listPlaces.es'
import listSegmentationsEN from '../../modules/segments/list/_common/listSegmentations.en'
import listSegmentationsPT from '../../modules/segments/list/_common/listSegmentations.pt'
import listSegmentationsES from '../../modules/segments/list/_common/listSegmentations.es'
import listServiceOrdersEN from '../../modules/serviceOrders/list/_common/listServiceOrders.en'
import listServiceOrdersPT from '../../modules/serviceOrders/list/_common/listServiceOrders.pt'
import listServiceOrdersES from '../../modules/serviceOrders/list/_common/listServiceOrders.es'
import listUsersEN from '../../modules/users/list/_common/listUsers.en'
import listUsersPT from '../../modules/users/list/_common/listUsers.pt'
import listUsersES from '../../modules/users/list/_common/listUsers.es'
import listGroupsEN from '../../modules/groups/list/_common/listGroups.en'
import listGroupsPT from '../../modules/groups/list/_common/listGroups.pt'
import listGroupsES from '../../modules/groups/list/_common/listGroups.es'
import listIntegrationsEN from '../../modules/integrations/list/_common/listIntegrations.en'
import listIntegrationsPT from '../../modules/integrations/list/_common/listIntegrations.pt'
import listIntegrationsES from '../../modules/integrations/list/_common/listIntegrations.es'
import logsPT from '../../modules/logs/_locales/logs.pt'
import logsES from '../../modules/logs/_locales/logs.es'
import logsEN from '../../modules/logs/_locales/logs.en'
import menuEN from '../../modules/menu/_common/menu.en'
import menuPT from '../../modules/menu/_common/menu.pt'
import menuES from '../../modules/menu/_common/menu.es'
import minicrudsEN from '../../modules/minicruds/_common/minicruds.en'
import minicrudsPT from '../../modules/minicruds/_common/minicruds.pt'
import minicrudsES from '../../modules/minicruds/_common/minicruds.es'
import placeTypesEN from '../../modules/placeTypes/_common/placeTypes.en'
import placeTypesPT from '../../modules/placeTypes/_common/placeTypes.pt'
import placeTypesES from '../../modules/placeTypes/_common/placeTypes.es'
import profilesEN from '../../modules/profiles/_common/profiles.en'
import profilesPT from '../../modules/profiles/_common/profiles.pt'
import profilesES from '../../modules/profiles/_common/profiles.es'
import projectsEN from '../../modules/projects/_common/projects.en'
import projectsPT from '../../modules/projects/_common/projects.pt'
import projectsES from '../../modules/projects/_common/projects.es'
import homeEN from '../../modules/home/_common/home.en'
import homePT from '../../modules/home/_common/home.pt'
import homeES from '../../modules/home/_common/home.es'
import qrcodesEN from '../../modules/qrcodes/_common/qrcodes.en'
import qrcodesPT from '../../modules/qrcodes/_common/qrcodes.pt'
import qrcodesES from '../../modules/qrcodes/_common/qrcodes.es'
import sendFormEN from '../../modules/places/sendForm/_common/sendForm.en'
import sendFormPT from '../../modules/places/sendForm/_common/sendForm.pt'
import sendFormES from '../../modules/places/sendForm/_common/sendForm.es'
import serviceOrdersEN from '../../modules/serviceOrders/_common/serviceOrders.en'
import serviceOrdersPT from '../../modules/serviceOrders/_common/serviceOrders.pt'
import serviceOrdersES from '../../modules/serviceOrders/_common/serviceOrders.es'
import containersServiceOrdersEN from '../../containers/serviceOrders/_common/serviceOrders.en'
import containersServiceOrdersPT from '../../containers/serviceOrders/_common/serviceOrders.pt'
import containersServiceOrdersES from '../../containers/serviceOrders/_common/serviceOrders.es'
import containersChecklistsEN from '../../containers/checklists/_common/checklists.en'
import containersChecklistsPT from '../../containers/checklists/_common/checklists.pt'
import containersChecklistsES from '../../containers/checklists/_common/checklists.es'
import containersAuditEN from '../../containers/audit/_common/audit.en'
import containersAuditPT from '../../containers/audit/_common/audit.pt'
import containersAuditES from '../../containers/audit/_common/audit.es'
import containersUsersEN from '../../containers/users/_common/users.en'
import containersUsersPT from '../../containers/users/_common/users.pt'
import containersUsersES from '../../containers/users/_common/users.es'
import containersPlacesEN from '../../containers/places/_common/places.en'
import containersPlacesPT from '../../containers/places/_common/places.pt'
import containersPlacesES from '../../containers/places/_common/places.es'
import containersQuestionsEN from '../../containers/questions/_common/questions.en'
import containersQuestionsPT from '../../containers/questions/_common/questions.pt'
import containersQuestionsES from '../../containers/questions/_common/questions.es'
import containersChecklistTypesEN from '../../containers/checklistTypes/_common/checklistTypes.en'
import containersChecklistTypesPT from '../../containers/checklistTypes/_common/checklistTypes.pt'
import containersChecklistTypesES from '../../containers/checklistTypes/_common/checklistTypes.es'
import containersAssetsEN from '../../containers/assets/_common/assets.en'
import containersAssetsPT from '../../containers/assets/_common/assets.pt'
import containersAssetsES from '../../containers/assets/_common/assets.es'
import sessionEN from '../../modules/session/_common/session.en'
import sessionPT from '../../modules/session/_common/session.pt'
import sessionES from '../../modules/session/_common/session.es'
import settingsEN from '../../modules/settings/_common/settings.en'
import settingsPT from '../../modules/settings/_common/settings.pt'
import settingsES from '../../modules/settings/_common/settings.es'
import shareFormEN from '../../modules/forms/share/_common/shareForm.en'
import shareFormPT from '../../modules/forms/share/_common/shareForm.pt'
import shareFormES from '../../modules/forms/share/_common/shareForm.es'
import templatesEN from '../../modules/templates/_common/templates.en'
import templatesPT from '../../modules/templates/_common/templates.pt'
import templatesES from '../../modules/templates/_common/templates.es'
import triggersEN from '../../modules/triggers/_common/triggers.en'
import triggersPT from '../../modules/triggers/_common/triggers.pt'
import triggersES from '../../modules/triggers/_common/triggers.es'
import tagsEN from '../../modules/tags/_common/tags.en'
import tagsPT from '../../modules/tags/_common/tags.pt'
import tagsES from '../../modules/tags/_common/tags.es'
import validationsEN from '../../modules/_common/validations.en'
import validationsPT from '../../modules/_common/validations.pt'
import validationsES from '../../modules/_common/validations.es'
import routinesEN from '../../modules/routines/_common/routines.en'
import routinesPT from '../../modules/routines/_common/routines.pt'
import routinesES from '../../modules/routines/_common/routines.es'
import listMasksEN from '../../modules/mask/list/_common/listMasks.en'
import listMasksPT from '../../modules/mask/list/_common/listMasks.pt'
import listMasksES from '../../modules/mask/list/_common/listMasks.es'
import editMasksEN from '../../modules/mask/edit/_common/editMasks.en'
import editMasksPT from '../../modules/mask/edit/_common/editMasks.pt'
import editMasksES from '../../modules/mask/edit/_common/editMasks.es'
import listServiceOrdersHistoryEN from '../../modules/serviceOrders/publicHistory/_common/listServiceOrdersHistory.en'
import listServiceOrdersHistoryPT from '../../modules/serviceOrders/publicHistory/_common/listServiceOrdersHistory.pt'
import listServiceOrdersHistoryES from '../../modules/serviceOrders/publicHistory/_common/listServiceOrdersHistory.es'
import listDynamicServiceOrdersEN from '../../modules/dynamicServiceOrders/list/_common/listDynamicServiceOrders.en'
import listDynamicServiceOrdersPT from '../../modules/dynamicServiceOrders/list/_common/listDynamicServiceOrders.pt'
import listDynamicServiceOrdersES from '../../modules/dynamicServiceOrders/list/_common/listDynamicServiceOrders.es'
import editDynamicServiceOrdersPT from '../../modules/dynamicServiceOrders/editV2/_common/editDynamicServiceOrders.pt'
import editDynamicServiceOrdersEN from '../../modules/dynamicServiceOrders/editV2/_common/editDynamicServiceOrders.en'
import editDynamicServiceOrdersES from '../../modules/dynamicServiceOrders/editV2/_common/editDynamicServiceOrders.es'
import shareDynamicServiceOrdersEN from '../../modules/dynamicServiceOrders/list/share/_common/shareDynamicServiceOrder.en'
import shareDynamicServiceOrdersPT from '../../modules/dynamicServiceOrders/list/share/_common/shareDynamicServiceOrder.pt'
import shareDynamicServiceOrdersES from '../../modules/dynamicServiceOrders/list/share/_common/shareDynamicServiceOrder.es'
import editSlaEN from '../../modules/configs/serviceOrderSla/edit/_common/editSla.en'
import editSlaPT from '../../modules/configs/serviceOrderSla/edit/_common/editSla.pt'
import editSlaES from '../../modules/configs/serviceOrderSla/edit/_common/editSla.es'
import listSlaEN from '../../modules/configs/serviceOrderSla/list/_common/listSla.en'
import listSlaPT from '../../modules/configs/serviceOrderSla/list/_common/listSla.pt'
import listSlaES from '../../modules/configs/serviceOrderSla/list/_common/listSla.es'

import listStocksEN from '../../modules/stocks/list/_common/listStocks.en'
import listStocksPT from '../../modules/stocks/list/_common/listStocks.pt'
import listStocksES from '../../modules/stocks/list/_common/listStocks.es'
import editStocksEN from '../../modules/stocks/edit/_common/editStocks.en'
import editStocksPT from '../../modules/stocks/edit/_common/editStocks.pt'
import editStocksES from '../../modules/stocks/edit/_common/editStocks.es'

import processesEN from '../../modules/processes/_common/processes.en'
import processesPT from '../../modules/processes/_common/processes.pt'
import processesES from '../../modules/processes/_common/processes.es'

import dashboardEN from '../../modules/dashboard/v2/_common/dashboard.en'
import dashboardPT from '../../modules/dashboard/v2/_common/dashboard.pt'
import dashboardES from '../../modules/dashboard/v2/_common/dashboard.es'

import mapEN from '../../modules/map/main/_common/map.en'
import mapPT from '../../modules/map/main/_common/map.pt'
import mapES from '../../modules/map/main/_common/map.es'

import componentsEN from '../../components/_common/components.en'
import componentsPT from '../../components/_common/components.pt'
import componentsES from '../../components/_common/components.es'

import exportEN from '../../modules/importsExports/export/_common/export.en'
import exportPT from '../../modules/importsExports/export/_common/export.pt'
import exportES from '../../modules/importsExports/export/_common/export.es'

import importEN from '../../modules/importsExports/importV2/_common/import.en'
import importPT from '../../modules/importsExports/importV2/_common/import.pt'
import importES from '../../modules/importsExports/importV2/_common/import.es'
import webhookEN from '../../modules/webhook/_common/webhook.en'
import webhookPT from '../../modules/webhook/_common/webhook.pt'
import webhookES from '../../modules/webhook/_common/webhook.es'
import triggerCallsEN from '../../modules/triggerCalls/_common/triggerCalls.en'
import triggerCallsPT from '../../modules/triggerCalls/_common/triggerCalls.pt'
import triggerCallsES from '../../modules/triggerCalls/_common/triggerCalls.es'
import screensEN from '../../modules/screens/_common/screens.en'
import screensPT from '../../modules/screens/_common/screens.pt'
import screensES from '../../modules/screens/_common/screens.es'
import contractsEN from '../../modules/contracts/_common/contracts.en'
import contractsPT from '../../modules/contracts/_common/contracts.pt'
import contractsES from '../../modules/contracts/_common/contracts.es'
import publicTokenEN from '../../modules/publicTokens/_common/publicToken.en'
import publicTokenPT from '../../modules/publicTokens/_common/publicToken.pt'
import publicTokenES from '../../modules/publicTokens/_common/publicToken.es'
import editLinkTreeItemsEN from '../../modules/linkTreeItems/edit/_common/editLinkTreeItems.en'
import editLinkTreeItemsPT from '../../modules/linkTreeItems/edit/_common/editLinkTreeItems.pt'
import editLinkTreeItemsES from '../../modules/linkTreeItems/edit/_common/editLinkTreeItems.es'
import listLinkTreesEN from '../../modules/linkTrees/list/_common/listLinkTrees.en'
import listLinkTreesPT from '../../modules/linkTrees/list/_common/listLinkTrees.pt'
import listLinkTreesES from '../../modules/linkTrees/list/_common/listLinkTrees.es'
import editLinkTreeEN from '../../modules/linkTrees/edit/_common/editLinkTree.en'
import editLinkTreePT from '../../modules/linkTrees/edit/_common/editLinkTree.pt'
import editLinkTreeES from '../../modules/linkTrees/edit/_common/editLinkTree.es'
import helpEN from '../../containers/help/_common/help.en'
import helpPT from '../../containers/help/_common/help.pt'
import helpES from '../../containers/help/_common/help.es'
import availabilityEN from '../../modules/availability/_common/availability.en'
import availabilityPT from '../../modules/availability/_common/availability.pt'
import availabilityES from '../../modules/availability/_common/availability.es'

const resources = {
  en: {
    common: commonEN,
    validations: validationsEN,
    settings: settingsEN,
    editPermissions: editPermissionsEN,
    menu: menuEN,
    profiles: profilesEN,
    session: sessionEN,
    components: componentsEN,
    help: helpEN,

    // Service Orders
    serviceOrders: { ...serviceOrdersEN, ...containersServiceOrdersEN },
    editServiceOrder: editServiceOrderEN,
    listServiceOrders: listServiceOrdersEN,
    duplicates: duplicatesEn,

    // Service Orders History
    listServiceOrdersHistory: listServiceOrdersHistoryEN,

    // Places
    places: containersPlacesEN,
    listPlaces: listPlacesEN,
    levelsSettings: levelsSettingsEN,
    editPlace: editPlaceEN,
    sendForm: sendFormEN,

    // Assets
    assets: containersAssetsEN,
    listAsset: listAssetEN,
    editAsset: editAssetEN,

    // Buckets
    editBucket: editBucketEN,
    listBuckets: listBucketsEN,

    // QR Codes
    qrcodes: qrcodesEN,

    // Dynamic SO
    listDynamicServiceOrders: listDynamicServiceOrdersEN,
    editDynamicServiceOrders: editDynamicServiceOrdersEN,
    shareDynamicServiceOrders: shareDynamicServiceOrdersEN,

    // Forms
    listForms: listFormsEN,
    editFormV2: editFormV2EN,
    shareForm: shareFormEN,

    // Users
    users: containersUsersEN,
    listUsers: listUsersEN,
    editUser: editUserEN,

    // Groups
    listGroups: listGroupsEN,

    // Contracts
    contracts: contractsEN,

    // Integrations
    listIntegrations: listIntegrationsEN,

    // Checklists
    checklists: containersChecklistsEN,
    listChecklists: listChecklistsEN,
    editChecklist: editChecklistEN,

    // Questions
    questions: containersQuestionsEN,

    // Checklist Types
    checklistTypes: containersChecklistTypesEN,

    // Audit
    audit: containersAuditEN,

    // Errors
    errors: errorsEN,

    // Segmentations
    listSegmentations: listSegmentationsEN,
    editSegmentation: editSegmentationEN,

    //Non-compliance
    listNonCompliance: listNonComplianceEN,
    listPlaceNonCompliance: listPlaceNonComplianceEN,

    //Templates
    templates: templatesEN,

    // Triggers
    triggers: triggersEN,

    // Tags
    tags: tagsEN,

    // Profiles
    editProfile: editProfileEN,

    // Logs
    listLogs: listLogsEN,
    logs: logsEN,

    // Minicruds
    minicruds: minicrudsEN,

    //PlaceTypes
    placeTypes: placeTypesEN,
    //Projects
    projects: projectsEN,

    //Home
    home: homeEN,

    //Configs
    editSemaphore: editSemaphoreEN,
    editServiceOrderAutomaticDistribution: editServiceOrderAutomaticDistributionEN,

    //Routines
    routines: routinesEN,

    //Masks
    editMasks: editMasksEN,
    listMasks: listMasksEN,

    // Stocks
    listStocks: listStocksEN,
    editStocks: editStocksEN,

    // SLA
    editSla: editSlaEN,
    listSla: listSlaEN,

    // Processes
    processes: processesEN,

    // Dashboard
    dashboard: dashboardEN,

    // Map
    map: mapEN,

    // Exports
    export: exportEN,

    // Imports
    import: importEN,

    // Webhooks
    webhook: webhookEN,

    // Trigger Calls
    triggerCalls: triggerCallsEN,

    // Public Tokens
    publicToken: publicTokenEN,

    // Link Trees
    editLinkTreeItems: editLinkTreeItemsEN,
    listLinkTrees: listLinkTreesEN,
    editLinkTree: editLinkTreeEN,

    // Screens
    screens: screensEN,

    // Availability
    availability: availabilityEN
  },
  pt: {
    common: commonPT,
    validations: validationsPT,
    settings: settingsPT,
    editPermissions: editPermissionsPT,
    menu: menuPT,
    profiles: profilesPT,
    session: sessionPT,
    components: componentsPT,
    help: helpPT,

    // Service Orders
    serviceOrders: { ...serviceOrdersPT, ...containersServiceOrdersPT },
    editServiceOrder: editServiceOrderPT,
    listServiceOrders: listServiceOrdersPT,
    duplicates: duplicatesPt,

    // Service Orders History
    listServiceOrdersHistory: listServiceOrdersHistoryPT,

    // Places
    places: containersPlacesPT,
    listPlaces: listPlacesPT,
    levelsSettings: levelsSettingsPT,
    editPlace: editPlacePT,
    sendForm: sendFormPT,

    // Assets
    assets: containersAssetsPT,
    listAsset: listAssetPT,
    editAsset: editAssetPT,

    // Buckets
    editBucket: editBucketPT,
    listBuckets: listBucketsPT,

    // QR Codes
    qrcodes: qrcodesPT,

    // Dynamic SO
    listDynamicServiceOrders: listDynamicServiceOrdersPT,
    editDynamicServiceOrders: editDynamicServiceOrdersPT,
    shareDynamicServiceOrders: shareDynamicServiceOrdersPT,

    // Forms
    listForms: listFormsPT,
    editFormV2: editFormV2PT,
    shareForm: shareFormPT,

    // Users
    users: containersUsersPT,
    listUsers: listUsersPT,
    editUser: editUserPT,

    // Groups
    listGroups: listGroupsPT,

    // Contracts
    contracts: contractsPT,

    // Integrations
    listIntegrations: listIntegrationsPT,

    // Checklists
    checklists: containersChecklistsPT,
    listChecklists: listChecklistsPT,
    editChecklist: editChecklistPT,

    // Questions
    questions: containersQuestionsPT,

    // Checklist Types
    checklistTypes: containersChecklistTypesPT,

    // Audit
    audit: containersAuditPT,

    // Errors
    errors: errorsPT,

    // Segmentations
    listSegmentations: listSegmentationsPT,
    editSegmentation: editSegmentationPT,

    //Non-compliance
    listNonCompliance: listNonCompliancePT,
    listPlaceNonCompliance: listPlaceNonCompliancePT,

    //Templates
    templates: templatesPT,

    // Triggers
    triggers: triggersPT,

    // Tags
    tags: tagsPT,

    // Profiles
    editProfile: editProfilePT,

    // Logs
    listLogs: listLogsPT,
    logs: logsPT,

    // Minicruds
    minicruds: minicrudsPT,

    // PlaceTypes
    placeTypes: placeTypesPT,
    //Projects
    projects: projectsPT,

    //Home
    home: homePT,

    //Configs
    editSemaphore: editSemaphorePT,
    editServiceOrderAutomaticDistribution: editServiceOrderAutomaticDistributionPT,

    //Routines
    routines: routinesPT,

    //Maskss
    editMasks: editMasksPT,
    listMasks: listMasksPT,

    // Stocks
    listStocks: listStocksPT,
    editStocks: editStocksPT,

    // SLA
    editSla: editSlaPT,
    listSla: listSlaPT,

    // Processes
    processes: processesPT,

    // Dashboard
    dashboard: dashboardPT,

    // Map
    map: mapPT,

    // Exports
    export: exportPT,

    // Imports
    import: importPT,

    // Webhooks
    webhook: webhookPT,

    // Trigger Calls
    triggerCalls: triggerCallsPT,

    // Public Tokens
    publicToken: publicTokenPT,

    // Link Trees
    editLinkTreeItems: editLinkTreeItemsPT,
    listLinkTrees: listLinkTreesPT,
    editLinkTree: editLinkTreePT,

    // Screens
    screens: screensPT,

    // Availability
    availability: availabilityPT
  },
  es: {
    common: commonES,
    validations: validationsES,
    settings: settingsES,
    editPermissions: editPermissionsES,
    menu: menuES,
    profiles: profilesES,
    session: sessionES,
    components: componentsES,
    help: helpES,

    // Service Orders
    serviceOrders: { ...serviceOrdersES, ...containersServiceOrdersES },
    editServiceOrder: editServiceOrderES,
    listServiceOrders: listServiceOrdersES,
    duplicates: duplicatesEs,

    // Service Orders History
    listServiceOrdersHistory: listServiceOrdersHistoryES,

    // Places
    places: containersPlacesES,
    listPlaces: listPlacesES,
    levelsSettings: levelsSettingsES,
    editPlace: editPlaceES,
    sendForm: sendFormES,

    // Assets
    assets: containersAssetsES,
    listAsset: listAssetES,
    editAsset: editAssetES,

    // Buckets
    editBucket: editBucketES,
    listBuckets: listBucketsES,

    // QR Codes
    qrcodes: qrcodesES,

    // Dynamic SO
    listDynamicServiceOrders: listDynamicServiceOrdersES,
    editDynamicServiceOrders: editDynamicServiceOrdersES,
    shareDynamicServiceOrders: shareDynamicServiceOrdersES,

    // Forms
    listForms: listFormsES,
    editFormV2: editFormV2ES,
    shareForm: shareFormES,

    // Users
    users: containersUsersES,
    listUsers: listUsersES,
    editUser: editUserES,

    // Groups
    listGroups: listGroupsES,

    // Integrations
    listIntegrations: listIntegrationsES,

    // Checklists
    checklists: containersChecklistsES,
    listChecklists: listChecklistsES,
    editChecklist: editChecklistES,

    // Questions
    questions: containersQuestionsES,

    // Checklist Types
    checklistTypes: containersChecklistTypesES,

    // Audit
    audit: containersAuditES,

    // Errors
    errors: errorsES,

    // Segmentations
    listSegmentations: listSegmentationsES,
    editSegmentation: editSegmentationES,

    //Non-compliance
    listNonCompliance: listNonComplianceES,
    listPlaceNonCompliance: listPlaceNonComplianceES,

    //Templates
    templates: templatesES,

    // Triggers
    triggers: triggersES,

    // Tags
    tags: tagsES,

    // Profiles
    editProfile: editProfileES,

    // Logs
    listLogs: listLogsES,
    logs: logsES,

    // Minicruds
    minicruds: minicrudsES,

    // PlaceTypes
    placeTypes: placeTypesES,
    //Projects
    projects: projectsES,

    //Home
    home: homeES,

    //Configs
    editSemaphore: editSemaphoreES,
    editServiceOrderAutomaticDistribution: editServiceOrderAutomaticDistributionES,

    //Routines
    routines: routinesES,

    //Masks
    editMasks: editMasksES,
    listMasks: listMasksES,

    // Stocks
    listStocks: listStocksES,
    editStocks: editStocksES,

    // SLA
    editSla: editSlaES,
    listSla: listSlaES,

    // Processes
    processes: processesES,

    // Dashboard
    dashboard: dashboardES,

    // Map
    map: mapES,

    // Exports
    export: exportES,

    // Imports
    import: importES,

    // Webhooks
    webhook: webhookES,

    // Trigger Calls
    triggerCalls: triggerCallsES,

    // Contracts
    contracts: contractsES,

    // Public Tokens
    publicToken: publicTokenES,

    // Link Trees
    editLinkTreeItems: editLinkTreeItemsES,
    listLinkTrees: listLinkTreesES,
    editLinkTree: editLinkTreeES,

    // Screens
    screens: screensES,

    // Availability
    availability: availabilityES
  }
}

export default resources
